@if (vm$ | async; as vm) {
  <app-agenda title="Agenda" [months]="vm.months" [itemTemplate]="serviceItem"
    upcomingEmptyMessage="No hay próximos servicios divinos en este período."
    [loading]="vm.loading" [error]="vm.error" [canView]="vm.canView"
    emptyMessage="Sin servicios divinos registrados este mes." (retry)="retry()"></app-agenda>
  <ng-template #serviceItem let-service let-isPast="isPast">
    <a class="service-item" [class.is-past]="isPast" [routerLink]="['/units', service.organizationUnitId || vm.unitId, 'divine-services', service.id]">
      <span class="service-time">{{ service.startAt | date:'HH:mm' }}</span>
      <span class="service-info">
        <strong>{{ service.divineServiceTypeName || 'Servicio divino' }}</strong>
        @if (vm.showCommunity && service.organizationUnitName) { <span>{{ service.organizationUnitName }}</span> }
        @if (service.bibleText) { <small>{{ service.bibleText }}</small> }
      </span>
      <mat-icon>chevron_right</mat-icon>
    </a>
  </ng-template>
} @else {
  <p role="status">Cargando agenda…</p>
}
